<template>
  <div class="container_box">
    <div class="bg">
      <img src="../assets/imgs/banner1-1.png" alt="" />
    </div>
    <div class="content">
      <!-- 竞价大厅标题 -->
      <div class="flex between mb-20 pt-15">
        <div class="bold9 size20 color1">
          供应商信息-我中标的
          <!-- <span style="font-size: 14px; color: #ccd9e9"
            >I was involved</span
          > -->
        </div>
      </div>

      <!-- 表格 -->
      <el-table
        :header-cell-style="{
          background: '#3B426C',
          color: '#ffffff',
          padding: '0px',
          height: '40px',
        }"
        :cell-style="{ padding: '0px' }"
        :row-style="{ height: '40px' }"
        class="mb-10"
        :data="tableData"
        stripe
        style="font-size: 14px"
      >
        <el-table-column
          prop="participationMode"
          label="参与方式"
          align="center"
          width="100px"
        >
          <template slot-scope="scope">
            {{ scope.row.participationMode == 1 ? "公开" : "非公开" }}
          </template>
        </el-table-column>
        <el-divider direction="vertical"></el-divider>
        <el-table-column
          prop="sessionNum"
          label="场次号"
          align="center"
          width="127px"
        >
        </el-table-column>
        <el-table-column
          prop="title"
          show-overflow-tooltip
          label="竞价标题"
          align="center"
          width="148px"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="publishCompany"
          label="发起单位"
          align="center"
          width="192px"
        >
        </el-table-column>
        <el-table-column label="起止时间" width="202px" align="center">
          <template slot-scope="scope">
            <div>{{ scope.row.beginTime }}至 {{ scope.row.endTime }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="dealTime"
          label="中标时间"
          align="center"
          width="170px"
        >
        </el-table-column>

        <el-table-column prop="lie6" label="操作" align="center">
          <template slot-scope="scope">
            <div @click="goDetail(scope.row.id)" class="pointer">查看详情</div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div style="padding: 17px 50px 17px 0px" class="bg-color border-box">
        <el-pagination
          class="pagination flex flex-end"
          prev-text="上一页"
          next-text="下一页"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNum"
          layout="prev,pager, next,slot"
          :total="total"
        >
          <div style="color: #ccd9e9; margin-left: 160px">
            到第
            <el-input
              v-model="queryInfo.pageNum"
              oninput="value=value.replace(/[^\d.]/g,'')"
            ></el-input
            >页/共{{ Math.ceil(total / queryInfo.pageSize) }}页
          </div>
          <div class="btn">确定</div>
        </el-pagination>
      </div>
    </div>

    <Footer class="mt-15" />
  </div>
</template>

<script>
import Footer from "@/components/Footer";

export default {
  components: { Footer },

  data() {
    return {
      //表单数据
      queryInfo: {
        pageSize: 10,
        pageNumb: 1,
        userId: window.sessionStorage.getItem("userId"),
      },
      message: "155,432",
      tableData: [],
      total: 0,
    };
  },
  mounted() {
    this.getZhongBiaoData();
  },
  methods: {
    //获取我中标的信息
    async getZhongBiaoData() {
      const { data: res } = await this.$axios.get(
        "/api/supplierService/getBiddingDeal",
        {
          params: this.queryInfo,
          headers: {
            token: window.sessionStorage.getItem("token"),
          },
        }
      );
      if (res.code == 200) {
        res.rows.some((item) => {
          item.endTime = item.endTime.slice(0, 10);
          item.beginTime = item.beginTime.slice(0, 10);
        });
        this.tableData = res.rows;
        this.total = res.total;
      } else {
        console.log(res);
      }
    },
    //跳转详情页
    goDetail(id) {
      window.sessionStorage.setItem("jjId", id);
      this.$router.push("/zhongbiaodetail");
    },
    //当前页
    handleCurrentChange(val) {
      this.queryInfo.pageNum = val;
      this.getZhongBiaoData();
    },
  },
};
</script>

<style scoped lang="less">
.content_box {
  background: url("../assets/imgs/bg.png") no-repeat;
  padding-bottom: 43px;
}
.content {
  width: 1200px;
  margin: auto;
}
/deep/.el-table__empty-text {
  line-height: 300px;
}
/deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
  background-color: #f3f6fb !important;
}
/deep/.el-table__header tr.el-table__header th {
  padding: 0 !important;
}
/deep/.el-table__body tr.el-table__body td {
  padding: 0 !important;
}
/deep/.el-table th.el-table__cell > .cell {
  border-right: 1px solid #fff;
}
/deep/.el-table .cell {
  border-right: 1px solid #95b3db;
}
/deep/.el-table td.el-table__cell {
  border-bottom: none;
}
//表格单元格右边框
/deep/.el-table__cell > .cell {
  border-right: 1px solid #95b3db;
}
//取消表头单元格最后一列右边框
/deep/.el-table th.el-table__cell:nth-child(7) > .cell {
  border-right: none;
}
//最后一列不要右边框
/deep/.el-table__cell:last-of-type > .cell {
  border-right: none;
}
.buttonB {
  width: 60px !important;
  height: 30px !important;
  font-size: 14px !important;
  color: #fff !important;
  border-radius: 10px !important;
  padding: 0 !important;
  margin-top: 5px !important;
  line-height: 30px !important;
}
.icon {
  font-size: 8px;
  color: #95b3db;
  position: absolute;
  top: 15px;
  left: 82px;
}
/deep/.pagination.el-pagination span {
  width: 80px;
  height: 30px;
  border: 1px solid #1c65c4;
  border-radius: 25px;
  color: #3b426b;
  font-weight: bold;
  font-size: 14px;
}
/deep/.pagination.el-pagination li {
  color: #ccd9e9;
}
/deep/.pagination.el-pagination li.active {
  color: #3b426b;
}
/deep/.el-pagination .el-input {
  margin-right: 0 !important;
  width: 35px;
}
/deep/.el-pagination .el-input__inner {
  width: 35px;
  height: 30px;
  border: 1px solid #ccd9e9;
  border-radius: 8px;
  padding: 0 !important;
}
.btn {
  width: 80px;
  height: 30px;
  border-radius: 25px;
  background-color: #1c65c4;
  color: #fff;
  text-align: center;
  line-height: 30px;
  margin-left: 24px;
  cursor: pointer;
}
</style>